import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "snav",
  "aria-label": "Sections des paramètres"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: item.to,
        to: item.to,
        class: "snav-link",
        "active-class": "",
        "exact-active-class": "is-active"
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: _normalizeClass(item.icon),
            "aria-hidden": "true"
          }, null, 2),
          _createElementVNode("span", null, _toDisplayString(item.label), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
}